import { render, staticRenderFns } from "./CaseConfigPermissionFieldsets.vue?vue&type=template&id=271a0732"
import script from "./CaseConfigPermissionFieldsets.vue?vue&type=script&lang=js"
export * from "./CaseConfigPermissionFieldsets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports